/* Clear Cart: drawer-friendly, bubble-safe, Safari-safe, auto-close when empty */
(function () {
  const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Helpers ---------- */

  function showDrawerSpinner() {
    try {
      const live = document.getElementById('CartDrawer-LineItemStatus');
      if (live) {
        live.textContent = live.getAttribute('data-loading-text') || 'Loading…';
        live.removeAttribute('aria-hidden');
      }
      const drawer = document.getElementById('CartDrawer');
      drawer?.classList.add('loading');
    } catch (_) {}
  }

  function hideDrawerSpinner() {
    try {
      const live = document.getElementById('CartDrawer-LineItemStatus');
      if (live) {
        live.textContent = '';
        live.setAttribute('aria-hidden', 'true');
      }
      const drawer = document.getElementById('CartDrawer');
      drawer?.classList.remove('loading');
    } catch (_) {}
  }

  function syncVisibility(btn) {
    if (!btn) return;
    const hideWhenEmpty = btn.dataset.hideWhenEmpty === 'true';
    fetch(`${shopRoot}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(r => r.json())
      .then(cart => {
        const count = cart?.item_count || 0;
        const wrap = btn.closest('.cart__clear-cart-link');
        if (count === 0) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
        if (hideWhenEmpty && wrap) wrap.style.display = count === 0 ? 'none' : '';
      })
      .catch(() => {});
  }

  async function swapDrawerAndBubble() {
    const res = await fetch(`${shopRoot}?sections=cart-drawer,cart-icon-bubble`, {
      credentials: 'same-origin'
    });
    const sections = await res.json();

    // Drawer
    try {
      const host = document.getElementById('CartDrawer');
      if (host && sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const next = doc.querySelector('#CartDrawer');
        if (next) host.innerHTML = next.innerHTML;
      }
    } catch (err) {
      console.warn('Drawer swap failed', err);
    }

    // Bubble (update innerHTML only)
    try {
      const bubbleMount = document.getElementById('cart-icon-bubble');
      if (bubbleMount && sections['cart-icon-bubble']) {
        const bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const nextBubble = bdoc.getElementById('cart-icon-bubble');
        if (nextBubble) bubbleMount.innerHTML = nextBubble.innerHTML;
      }
    } catch (err) {
      console.warn('Bubble swap failed', err);
    }

    // Keep drawer open & accessible
    try {
      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) {
        const nowEmpty = !!drawerEl.querySelector('.drawer__inner-empty');
        drawerEl.classList.toggle('is-empty', nowEmpty);
        drawerEl.classList.add('animate', 'active');
        if (typeof drawerEl.setHeaderCartIconAccessibility === 'function') {
          drawerEl.setHeaderCartIconAccessibility();
        }
      }
    } catch (err) {
      console.warn('Drawer post-swap tasks failed', err);
    }
  }

  async function updateHeaderBubbleCount() {
    try {
      const res = await fetch(`${shopRoot}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      const cart = await res.json();
      const count = cart?.item_count || 0;

      const mount = document.getElementById('cart-icon-bubble');
      if (!mount) return;

      const badge =
        mount.querySelector('[data-cart-count]') ||
        mount.querySelector('.cart-count-bubble') ||
        mount.querySelector('.cart-count') ||
        mount;

      if (badge.hasAttribute('data-cart-count')) {
        badge.setAttribute('data-cart-count', String(count));
      } else {
        badge.textContent = count > 0 ? String(count) : '';
      }

      if (count > 0) {
        badge.classList.remove('hidden', 'visually-hidden');
        badge.removeAttribute('aria-hidden');
      } else {
        badge.classList.add('hidden');
        badge.setAttribute('aria-hidden', 'true');
      }

      const trigger = mount.querySelector('a,button,[role="button"]') || mount;
      if (trigger) trigger.setAttribute('aria-label', `${count} items in cart`);
    } catch (err) {
      console.warn('Bubble count update failed', err);
    }
  }

  // New: after clear, wait a bit and close the drawer if empty
  async function closeDrawerIfEmpty(delay = 700) {
    try {
      const res = await fetch(`${shopRoot}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      const cart = await res.json();
      if ((cart?.item_count || 0) === 0) {
        setTimeout(() => {
          const drawerEl = document.querySelector('cart-drawer');
          const stillEmpty = drawerEl?.querySelector('.drawer__inner-empty');
          if (drawerEl && stillEmpty && typeof drawerEl.close === 'function') {
            drawerEl.close();
          }
        }, delay);
      }
    } catch (_) {}
  }

  /* ---------- Click handler ---------- */

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-clear-cart]');
    if (!btn) return;
    e.preventDefault();

    if (btn.getAttribute('aria-disabled') === 'true') return;

    if (btn.dataset.confirm === 'true') {
      const msg = btn.dataset.confirmMessage || 'Clear all items from your cart?';
      if (!window.confirm(msg)) return;
    }

    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    showDrawerSpinner();

    // 1) Clear cart – only alert if THIS fails
    try {
      const response = await fetch(`${shopRoot}cart/clear.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart/clear.js returned non-OK');
    } catch (err) {
      console.error('Failed to clear cart', err);
      hideDrawerSpinner();
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
      alert('There was an error clearing your cart. Please try again.');
      return;
    }

    // 2) Refresh UI (soft-fail)
    try {
      await swapDrawerAndBubble();
    } catch (err) {
      console.warn('UI refresh after clear failed softly:', err);
    }

    // 3) Notify listeners + force bubble to 0
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { action: 'clear' } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (_) {}
    try {
      await updateHeaderBubbleCount();
    } catch (_) {}

    // 4) Auto-close drawer a moment later if empty
    await closeDrawerIfEmpty(700);

    // 5) Cleanup
    hideDrawerSpinner();
    btn.removeAttribute('aria-busy');
    setTimeout(() => syncVisibility(btn), 200);
  });

  /* ---------- Initial bind ---------- */

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-clear-cart]').forEach(syncVisibility);
  });
})();
